import {
  CHECKLIST_EXTERNAL_AREA_PAGE_VIEWED_ANALYTICS,
  EXTERNAL_AREA_FINISH_BUTTON_CLICKED_ANALYTICS,
} from './types';

export const checklistExternalAreaPageViewedAnalytics = ({ photoSessionId }) => ({
  type: CHECKLIST_EXTERNAL_AREA_PAGE_VIEWED_ANALYTICS,
  extraProperties: {
    photoSessionId,
  },
});

export const trackChecklistExternalAreaFinishButtonClickedAction = ({ photoSessionId, isValid }) => ({
  type: EXTERNAL_AREA_FINISH_BUTTON_CLICKED_ANALYTICS,
  extraProperties: {
    photoSessionId,
    isValid,
  },
});
